var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search_wrap"},[_c('search-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }